import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { SettingsService } from './settings.service';
import { TenantService } from './tenant.service';

@Injectable()
export class TenantInterceptor implements HttpInterceptor {
  constructor(private _injector: Injector) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const settingsService = this._injector.get(SettingsService);

    if (settingsService.useMultitenant && this.isApiUrl(request.url, settingsService)) {
      const urlTenant = settingsService.currentTenant;
      const tenantService = this._injector.get(TenantService);
      tenantService.logoutIfNoTenant(urlTenant);

      const urlWithTenant = this.addTenantToUrl(request.url, urlTenant);
      request = request.clone({
        url: urlWithTenant,
      });
    }

    return next.handle(request);
  }

  isApiUrl = (url: string, settingsService: SettingsService) =>
    url.startsWith(settingsService.apis.default.url + '/api');

  private addTenantToUrl(url: string, tenant: string) {
    const urlParts = url.split('://');

    if (tenant && urlParts.length >= 2) {
      const [protocol, ...restOfUrl] = urlParts;
      const urlWithTenant = [protocol, '://', tenant, '.', ...restOfUrl].join('');
      return urlWithTenant;
    }
    return url;
  }
}
